import { useState, useEffect } from 'react';
import { getBranchOffices } from 'services/filters';
import { BranchOffices } from 'types';
import { loggerInfo } from 'utils/infoLog';

type branchOfficeOptionsProps = {
	id: string;
	value: string;
}[];

export const useBranchOffices = () => {
	const [isLoading, setLoading] = useState<boolean>(false);
	const [hasError, setError] = useState<boolean>(false);
	const [branchOfficeOptions, setBranchOfficeOptions] =
		useState<branchOfficeOptionsProps>([]);

	const fetchBranchOfficeOptions = async (): Promise<void> => {
		setLoading(true);
		setError(false);
		try {
			const res = await getBranchOffices({ withCandidate: true });
			const { branchOffices } = res.data.content;
			const formattedBranchOffices = branchOffices.map(
				(branchOffice: BranchOffices) => ({
					id: branchOffice.id,
					value: branchOffice.name,
				}),
			);

			setBranchOfficeOptions([...formattedBranchOffices]);
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'app',
				location: 'useBranchOffices',
			});
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchBranchOfficeOptions();
	}, []);

	return {
		isLoading,
		hasError,
		branchOfficeOptions,
		onRetry: fetchBranchOfficeOptions,
	};
};
